import { ShareOutlineIcon } from "./icons/ShareOutlineIcon";

/*
 * The share button is chrome and always renders, even when the title/summary
 * text is empty in live mode. The light/dark handling is preserved from the
 * scanned page so the share button + text stay legible on light primary
 * colors; the reference (dark default) resolves to the white variant.
 *
 * Sizes match the Social share button (`35px`, `xs:` `48px`) so it shrinks
 * with the phone mockup / narrow viewport the same way.
 */
const EventHeader = ({
  title,
  summary,
  titleFont,
  textFont,
  light,
  onShare,
  shareLabel = "Share",
}) => (
  <div className="flex flex-col gap-5" id="eventHeader">
    <div className="flex justify-end">
      <button
        type="button"
        onClick={onShare}
        aria-label={shareLabel}
        className="flex h-[35px] w-[35px] xs:h-[48px] xs:w-[48px] cursor-pointer items-center justify-center rounded border duration-500"
        style={{
          backgroundColor: light ? "rgb(0 0 0 / .15)" : "rgb(255 255 255 / .15)",
          borderColor: light ? "rgb(0 0 0 / .18)" : "rgb(255 255 255 / .18)",
        }}
      >
        <ShareOutlineIcon size={24} color={light ? "#000000" : "#FFFFFF"} />
      </button>
    </div>
    {(title || summary) && (
      <div className="flex flex-col gap-2.5 p-3">
        {title && (
          <h1
            className="text-center text-lg xs:text-xl xsm:text-2xl font-bold leading-[1.25]"
            style={{
              fontFamily: titleFont,
              color: light ? "#000000" : "#ffffff",
              overflowWrap: "anywhere",
            }}
          >
            {title}
          </h1>
        )}
        {summary && (
          <p
            className="text-center text-base leading-5.5 font-normal"
            style={{
              fontFamily: textFont,
              color: light ? "rgb(0 0 0 / 0.8)" : "#ffffff",
              overflowWrap: "anywhere",
              whiteSpace: "pre-line",
            }}
          >
            {summary}
          </p>
        )}
      </div>
    )}
  </div>
);

export default EventHeader;
